export const itemsTypes = [
  { id: 'Category', name: 'resources.items.types.category' },
  { id: 'Inventory', name: 'resources.items.types.inventory' },
  { id: 'Service', name: 'resources.items.types.service' },
  { id: 'NonInventory', name: 'resources.items.types.nonInventory' },
];
